import App from './App.svelte';
import { addMessages, init, getLocaleFromNavigator } from 'svelte-i18n';
import en from './assets/i18n/en.json';
import pt from './assets/i18n/pt.json';
const storageLocale = localStorage.getItem('lang');
addMessages('en', en);
addMessages('pt', pt);
init({
    fallbackLocale: 'en',
    initialLocale: storageLocale ? storageLocale : getLocaleFromNavigator(),
});
const app = new App({
    target: document.body,
});
export default app;
